import { defineComponent } from "vue";
import InputWidget from "./InputWidget";

export default defineComponent({
    components: {
        InputWidget,
    },

    template: `
        <InputWidget :label="label" :required="required" class="InputText" :class="{ 'InputText--icon': icon, 'InputText--error': error }" :error="error">
            <i v-if="icon" class="InputText__icon">
                <svg v-if="icon == 'thunder'" xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
                    <path d="M17.8119 3H10.6174C10.3931 3 10.2809 3 10.1819 3.03416C10.0943 3.06437 10.0145 3.11367 9.94835 3.17849C9.87351 3.25179 9.82335 3.35212 9.72301 3.55279L4.47301 14.0528C4.23341 14.532 4.11361 14.7716 4.14239 14.9664C4.16752 15.1364 4.26159 15.2886 4.40247 15.3872C4.5638 15.5 4.83168 15.5 5.36744 15.5H13.1244L9.37441 28L24.6158 12.1941C25.13 11.6609 25.3871 11.3942 25.4021 11.1661C25.4152 10.9681 25.3334 10.7756 25.1818 10.6475C25.0071 10.5 24.6367 10.5 23.8959 10.5H14.9994L17.8119 3Z" stroke="#005537" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                <svg v-if="icon == 'map'" xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
                    <path d="M15 16.75C17.0711 16.75 18.75 15.0711 18.75 13C18.75 10.9289 17.0711 9.25 15 9.25C12.9289 9.25 11.25 10.9289 11.25 13C11.25 15.0711 12.9289 16.75 15 16.75Z" stroke="#2CB34A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15 28C20 23 25 18.5228 25 13C25 7.47715 20.5228 3 15 3C9.47715 3 5 7.47715 5 13C5 18.5228 10 23 15 28Z" stroke="#2CB34A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </i>

            <input ref="input" :type="type" :value="modelValue" @input="onInput($event.target.value)" class="InputText__input" :required="required" :disabled="disabled" :placeholder="placeholder" />

            <div v-if="unit" class="InputText__unit">{{ unit }}</div>
        </InputWidget>
    `,

    emits: [
        'update:modelValue',
    ],

    props: {
        modelValue: { type: String },
        label: { type: String },
        type: { type: String, default: 'text' },
        placeholder: { type: String },
        icon: { type: String },
        unit: { type: String },
        mask: { type: String },

        error: { type: String },

        disabled: { type: Boolean },
        required: { type: Boolean },
    },

    mounted() {
        if (this.mask) {
            const $input = $(this.$refs.input);

            (<any>$input).mask(this.mask, {
                placeholder: this.mask.replaceAll('0', '_'),
            });
        }
    },

    methods: {
        onInput(val: any) {
            if (this.mask) {
                const $input = $(this.$refs.input);

                val = (<any>$input).masked();
            }

            this.$emit('update:modelValue', val);
        },
    }
});
